import { render, staticRenderFns } from "./health_surveillance.vue?vue&type=template&id=409088b6&scoped=true"
import script from "./health_surveillance.vue?vue&type=script&lang=js"
export * from "./health_surveillance.vue?vue&type=script&lang=js"
import style0 from "./health_surveillance.vue?vue&type=style&index=0&id=409088b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409088b6",
  null
  
)

export default component.exports